/** @format */

import {ValueList} from '../types';

/**
 * Вычисляет дельту (разницу между мин и макс) в списке значений.
 * Дельта используется для сжатия диапазона прогноза.
 * @param list
 */

const getValueDelta = (list: ValueList): number => {
  const values = Object.values(list);

  if (values.length === 0) {
    return 0;
  }

  return Math.max(...values) - Math.min(...values);
};

export {getValueDelta};
